import axios from 'axios';
import { FIRM_SETTINGS } from 'constants/constants';

export interface AiFirmSettingResponse {
  data: boolean;
}

export interface UpdateAiFirmSettingPayload {
  type: 'boolean';
  value: boolean;
}

export interface UpdateAiFirmSettingResponse {
  value: boolean;
}

/**
 * Fetches the AI features setting for the current firm
 */
export async function getAiFirmSetting(): Promise<boolean> {
  const response = await axios.get<AiFirmSettingResponse>(
    `${FIRM_SETTINGS}/ai_features_enabled`
  );
  return response.data.data;
}

/**
 * Updates the AI features setting for the current firm
 */
export async function updateAiFirmSetting(
  enabled: boolean
): Promise<boolean> {
  const response = await axios.put<UpdateAiFirmSettingResponse>(
    `${FIRM_SETTINGS}/ai_features_enabled`,
    {
      type: 'boolean',
      value: enabled,
    }
  );
  return response.data.value;
} 